var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CardFechamento',{class:_vm.propComponentePai === 'FechamentoFrenteDeCaixa' 
      ? 'w-50 mr-5' : ''}),_c('CardFormasDePagamento',{class:_vm.propComponentePai === 'FechamentoFrenteDeCaixa' 
      ? 'w-50 mr-5' : ''}),_c('CardTipoDePagamento',{class:_vm.propComponentePai === 'FechamentoFrenteDeCaixa' 
      ? 'w-50 ' : ''})],1)}
var staticRenderFns = []

export { render, staticRenderFns }